export default {
  seo: {
    home: {
      title: 'Artemida Studio — Soluções digitais criativas',
      description:
        'Criamos sites sob medida de qualquer complexidade: landing pages, sites corporativos e assistentes de IA.',
      keywords: 'desenvolvimento web, landing page, site corporativo, IA',
    },
    // 🔽 novo: SEO para a lista do blog
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Insights sobre desenvolvimento web, design, assistentes de IA e a criação de sites modernos para empresas.',
      keywords: 'blog, desenvolvimento web, design, ia, sites',
    },
  },

  header: {
    homeLink: 'Início',
    aboutUsLink: 'Sobre nós',
    servicesLink: 'Serviços',
    ourProjectsLink: 'Nossos projetos',
    contact: 'Contato',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription: 'Criamos sites sob medida de qualquer complexidade',
    contactUs: 'Fale conosco',
  },
  aboutUsSection: {
    aboutUsTitle: 'Sobre nós',
    aboutUsDescription:
      'Na Artemida Studio, somos especializados na criação de landing pages e sites corporativos sob medida que ajudam as empresas a construir uma forte presença online. Nossa missão é entregar soluções modernas, funcionais e visualmente impactantes, adaptadas às necessidades da sua marca.\n\n' +
      'Combinando criatividade, as tecnologias mais recentes e uma abordagem personalizada, desenvolvemos sites que não são apenas esteticamente atraentes, mas também rápidos, fáceis de usar e totalmente responsivos.\n\n' +
      'Se você precisa de uma landing page com alta conversão ou de um site corporativo profissional, a Artemida Studio está aqui para transformar sua visão em realidade com soluções personalizadas de alta qualidade.\n\n' +
      'Escolha profissionalismo e criatividade — vamos construir juntos o seu site perfeito!',
  },

  // Serviços (toda a seção controlada por i18n)
  services: {
    ourServices: 'Nossos serviços',
    servicesDescription:
      'Somos especializados em criar soluções digitais personalizadas e de alta qualidade para impulsionar o seu negócio',
    contactUs: 'Fale conosco',
    items: [
      {
        key: 'landing',
        title: 'Landing \n Page',
        descriptionList: [
          'Uma landing page bem planejada é uma ferramenta poderosa para atrair clientes, aumentar conversões e fortalecer a presença online da sua marca. Na Artemida Studio, criamos landing pages personalizadas de alta qualidade, alinhadas aos objetivos do seu negócio.',
          '✔️ Design moderno e único — Páginas visualmente impactantes e alinhadas à sua marca.',
          '✔️ Alta taxa de conversão — Layouts otimizados e CTAs envolventes para impulsionar o engajamento.',
          '✔️ Rápida e responsiva — Desempenho veloz e experiência fluida em todos os dispositivos.',
          '✔️ Pronta para SEO e marketing — Construída com as melhores práticas para melhorar a visibilidade e atrair tráfego orgânico.',
          '✔️ Totalmente personalizável — Cada detalhe ajustado às suas necessidades e à identidade do seu negócio.',
        ],
      },
      {
        key: 'corporate',
        title: 'Site \n corporativo',
        descriptionList: [
          'Um site corporativo profissional é essencial para gerar credibilidade, apresentar sua marca e engajar clientes. Na Artemida Studio, desenvolvemos sites corporativos sob medida que refletem os valores da sua empresa e destacam você no ambiente digital.',
          '✔️ Design profissional e único — Visual moderno e elegante, alinhado à identidade da sua marca.',
          '✔️ Totalmente personalizável — Cada elemento projetado para as metas e necessidades do seu negócio.',
          '✔️ Rápido e seguro — Otimizado para velocidade, segurança e desempenho impecável.',
          '✔️ SEO & marketing friendly — Desenvolvido segundo as melhores práticas para ampliar a visibilidade e atrair clientes potenciais.',
          '✔️ Mobile e fácil de usar — Design totalmente responsivo para uma experiência consistente em todos os dispositivos.',
          '✔️ Gestão de conteúdo simples — Atualizações fáceis com um CMS intuitivo.',
        ],
      },
      {
        key: 'ai',
        title: 'Integração de assistentes IA',
        descriptionList: [
          'Potencialize seu site com a IA! Na Artemida Studio, integramos assistentes de IA avançados que melhoram a experiência do usuário, automatizam tarefas e aumentam o engajamento. Seja um chatbot inteligente, suporte automatizado ou recomendações orientadas por IA, criamos soluções sob medida para o seu negócio.',
          '✔️ Suporte ao cliente 24/7 — Chatbots com IA atendem solicitações a qualquer hora, aumentando a satisfação.',
          '✔️ Integração transparente no site — Funciona de forma fluida dentro do seu site, ampliando funcionalidades sem interrupções.',
          '✔️ Experiência personalizada — Interações orientadas por IA, ajustadas às necessidades e preferências do usuário.',
          '✔️ Geração de leads e aumento de vendas — Engaje visitantes, capte contatos e conduza clientes à compra.',
          '✔️ Automação e eficiência — Simplifique processos, reduzindo carga de trabalho e tempo de resposta.',
          '✔️ Soluções de IA sob medida — Totalmente adaptáveis ao seu modelo de negócio e requisitos específicos.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Vamos falar sobre o seu projeto',
    placeholderName: 'Nome',
    placeholderPhone: 'Telefone',
    placeholderEmail: 'E-mail',
    placeholderMessage: 'Conte-nos sobre o seu projeto',
    sendButton: 'Enviar',
  },
};
